var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#E3DBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5168 21.689C36.1314 21.689 34.7634 22.2162 33.7057 23.2723L22.1284 34.8005C21.5093 35.4196 21.5093 36.4582 22.1284 37.0773L24.8501 39.7991V45.4389C24.8501 48.9365 27.6859 51.7722 31.1834 51.7722H43.8501C47.3477 51.7722 50.1835 48.9365 50.1835 45.4389V39.7991L52.9036 37.0773C53.5227 36.4582 53.5227 35.4196 52.9036 34.8005C52.3669 34.2638 50.4004 32.2878 48.6001 30.4955V26.439C48.6001 25.565 47.8908 24.8556 47.0168 24.8556C46.1412 24.8556 45.4335 25.565 45.4335 26.439V27.3794C43.7393 25.6932 41.8393 23.7853 41.3263 23.2723C40.2686 22.2162 38.9006 21.689 37.5168 21.689Z",
    fill: "#927BF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2f3b5f37d849d0d3333d1dd5b153000f.svg";
export { ForwardRef as ReactComponent };